import { z } from 'zod';

import { isNumber } from '../../../utils/common.util';

export const MaxValueValidationBlockSchema = z.number();
export type MaxValueValidationBlock = z.infer<
  typeof MaxValueValidationBlockSchema
>;

type IsMaxValue = (value: unknown, block: MaxValueValidationBlock) => boolean;
export const isMaxValue: IsMaxValue = (value, block) => {
  if (!isNumber(value)) {
    return false;
  }

  return value <= block;
};
